var render = function render(_c,_vm){return _c('p',{staticClass:"register-link"},[_vm._v("\n  "+_vm._s(_vm.props.regLabel)+"\n  "),_c('span',[_c('router-link',{attrs:{"to":{ name: _vm.props.leadsTo }}},[_vm._v("\n      "+_vm._s(_vm.props.regDesc)+"\n    ")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }